// extracted by mini-css-extract-plugin
export default {"container":"ToggleLanguage_container__lEKGU"};